import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'partial/components/Button';
import { usePlansContext } from 'partial/wrappers/PlansContext';

function EditBar() {
  const navigate = useNavigate();
  const { isUpdating, handleSubmit } = usePlansContext();
  return (
    <div className="w-full py-3 pl-3 pr-6 bg-gray-800 fixed bottom-0 z-10">
      <div className="flex justify-end gap-4">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="uppercase text-white px-2.5 py-1.5 text-sm leading-4"
          disabled={isUpdating}
        >
          cancel
        </button>
        <Button
          onClick={handleSubmit}
          size="sm"
          primary
          className="uppercase !px-4"
          disabled={isUpdating}
        >
          save changes
        </Button>
      </div>
    </div>
  );
}

export default EditBar;
